module.exports = __webpack_public_path__ + "img/buy.ebde1db6.png";